import { combineReducers } from "redux";
import { loadingReducer } from "./loading";
import { ILoadingState } from "./loading/types";
import { dialogsReducer } from "./dialogs";
import { IDialogsState } from "./dialogs/types";
import { ITranslationState } from "./translation/types";
import { translationReducer } from "./translation";
import { feedbackReducer } from "./feedback";
import { IFeedbackState } from "./feedback/types";

export interface IAppState {
  loading: ILoadingState;
  dialogs: IDialogsState;
  translation: ITranslationState;
  feedback: IFeedbackState;
}

const rootReducer = combineReducers({
  loading: loadingReducer,
  dialogs: dialogsReducer,
  translation: translationReducer,
  feedback: feedbackReducer
});

export default rootReducer;
